import {
  type AccountTier,
  type AdminAnnouncement,
  type AnnouncementAudience,
  type AnnouncementSeverity,
  getAnnouncementStatus,
} from "@/lib/announcements";

export const TIERS: AccountTier[] = ["starter", "plus", "pro", "elite", "agency", "comp", "admin_workspace", "super_admin"];

export type FormState = {
  title: string;
  body_md: string;
  video_url: string;
  severity: AnnouncementSeverity;
  audience: AnnouncementAudience;
  audience_tier: AccountTier;
  is_pinned: boolean;
  publish_now: boolean;
  scheduled_at: string;
  expires_at: string;
};

export const emptyForm: FormState = {
  title: "",
  body_md: "",
  video_url: "",
  severity: "info",
  audience: "all",
  audience_tier: "starter",
  is_pinned: false,
  publish_now: true,
  scheduled_at: "",
  expires_at: "",
};

export function toLocalInput(iso: string): string {
  const d = new Date(iso);
  const off = d.getTimezoneOffset();
  const local = new Date(d.getTime() - off * 60_000);
  return local.toISOString().slice(0, 16);
}

export function fromLocalInput(value: string): string | null {
  if (!value) return null;
  return new Date(value).toISOString();
}

export const fromAnnouncement = (a: AdminAnnouncement): FormState => ({
  title: a.title,
  body_md: a.body_md,
  video_url: a.video_url ?? "",
  severity: a.severity,
  audience: a.audience,
  audience_tier: a.audience_tier ?? "starter",
  is_pinned: a.is_pinned,
  publish_now: false,
  scheduled_at: a.published_at ? toLocalInput(a.published_at) : "",
  expires_at: a.expires_at ? toLocalInput(a.expires_at) : "",
});

export const previewSeverityClass: Record<AnnouncementSeverity, string> = {
  info: "bg-primary/10 text-primary",
  success: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  warning: "bg-amber-500/20 text-amber-700 dark:text-amber-300",
};

export const statusBadgeClass: Record<ReturnType<typeof getAnnouncementStatus>, string> = {
  draft: "bg-muted text-muted-foreground",
  scheduled: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  live: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  expired: "bg-muted text-muted-foreground line-through",
};

export const severityBadgeClass: Record<AnnouncementSeverity, string> = {
  info: "bg-primary/10 text-primary",
  success: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  warning: "bg-amber-500/20 text-amber-700 dark:text-amber-300",
};
